import { render, staticRenderFns } from "./TextSearchView.vue?vue&type=template&id=a56248e8&scoped=true&"
import script from "./TextSearchView.vue?vue&type=script&lang=js&"
export * from "./TextSearchView.vue?vue&type=script&lang=js&"
import style0 from "./TextSearchView.vue?vue&type=style&index=0&id=a56248e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56248e8",
  null
  
)

export default component.exports